import {
	type GetAllProjectsNameQuery,
	type GetAllProjectsNameQueryVariables,
	useGetAllProjectsNameLazyQuery,
} from "@repo/server-api";

import { useAsyncSelectCursorPaginatedLazyQuery } from "./AsyncSelectCursorPaginatedLazyQuery";

import type { AsyncSelectSearchHook } from "../BoundAsyncSelect";
import type { IdWithName } from "@repo/shared/common";

export function useAsyncSelectProjectQuery(
	type: GetAllProjectsNameQueryVariables["type"] = null,
	showDeleted: boolean = false,
): AsyncSelectSearchHook<IdWithName> {
	const [fetchProjects] = useGetAllProjectsNameLazyQuery();

	const buildVariables = (
		search: string,
		cursor: string | null,
	): GetAllProjectsNameQueryVariables => ({
		name: search || null,
		type,
		showDeleted,
		first: 20,
		after: cursor,
	});

	const extractItems = (data: GetAllProjectsNameQuery | undefined): IdWithName[] =>
		data?.allProjects?.nodes?.map((n) => ({
			id: n.id,
			name: n.name,
		})) ?? [];

	const extractEndCursor = (data: GetAllProjectsNameQuery | undefined): string | null =>
		data?.allProjects?.pageInfo?.endCursor ?? null;

	const extractHasNextPage = (data: GetAllProjectsNameQuery | undefined): boolean =>
		data?.allProjects?.pageInfo?.hasNextPage ?? false;

	return useAsyncSelectCursorPaginatedLazyQuery<
		GetAllProjectsNameQueryVariables,
		GetAllProjectsNameQuery,
		IdWithName
	>(fetchProjects, buildVariables, extractItems, extractEndCursor, extractHasNextPage);
}
